import { useTheme } from "styled-components";

import { RowContainer, GridItem, Flex, GridSize, FlexProps } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

interface ProgressBarProps {
  value: number;
  min?: number;
  max: number;
  showPercent?: boolean;
  label?: string;
  labelSM?: GridSize;
  labelXS?: GridSize;
  barSM?: GridSize;
  barXS?: GridSize;
  color?: string;
  showValue?: boolean;
  barHeight?: string;
  WrapperProps?: FlexProps;
}

export const ProgressBar = ({
  label,
  value,
  min = 0,
  max,
  showPercent,
  labelXS,
  labelSM,
  barXS,
  barSM,
  color,
  showValue = true,
  barHeight,
  WrapperProps,
}: ProgressBarProps) => {
  const theme = useTheme();
  const percent = Math.round(((value - min) * 100) / (max - min));
  return (
    <Flex wrap="wrap" margin="0.5rem 0" width="100%" {...WrapperProps}>
      {label && (
        <GridItem xs={labelXS || 12} sm={labelSM || labelXS}>
          <Typography>{label}</Typography>
        </GridItem>
      )}
      <GridItem xs={barXS || 12} sm={barSM || barXS}>
        <RowContainer
          height={barHeight || "1rem"}
          width="100%"
          bgColor={theme.colors.background.paper}
          justify="flex-start"
          borderRadius="0.4rem"
          overflow="hidden"
          position="relative"
          flexGrow={1}
        >
          {showValue && (
            <RowContainer zIndex={theme.zIndex.positiveOne} height="100%">
              <Typography color={theme.colors.common.white}>
                {showPercent ? `${percent}%` : `${value}/${max}`}
              </Typography>
            </RowContainer>
          )}
          <RowContainer
            transition="right 0.3s linear"
            position="absolute"
            left="0"
            top="0"
            bottom="0"
            right={`${100 - percent}%`}
            bgColor={color || theme.colors.primary.main}
          />
        </RowContainer>
      </GridItem>
    </Flex>
  );
};
